import {ellipsis} from 'ellipsed';

import {register} from '../vendor/theme-scripts/theme-sections';

import {productFormSection} from '../features/product-form';
import {swatchSection} from '../features/swatch';
import {tooltipSection} from '../features/tooltip';
import {productAddSection} from '../features/product-add';
import {productQuickShop} from '../features/product-quick-shop';

register('product-grid-item', [productFormSection, swatchSection, tooltipSection, productAddSection, productQuickShop]);